import { render, staticRenderFns } from "./law.vue?vue&type=template&id=2032a63f&scoped=true"
import script from "./law.vue?vue&type=script&lang=js"
export * from "./law.vue?vue&type=script&lang=js"
import style0 from "./law.vue?vue&type=style&index=0&id=2032a63f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2032a63f",
  null
  
)

export default component.exports